import { Box, IconButton, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';

interface CardProps {
  id?: string;
  project: string;
  currentAllocation: string;
  suggestedAllocation: string;
  colorCode: string;
  isAdd: boolean;
  pendingRequests?: boolean;
  setSuggestedAllocation: (value: string) => void;
}

const ProjectMemberAllocationCard = ({
  id,
  project,
  currentAllocation,
  suggestedAllocation,
  colorCode,
  isAdd,
  setSuggestedAllocation,
  pendingRequests
}: CardProps): JSX.Element => {
  const [isEditing, setIsEditing] = useState(!isAdd);
  const [suggestedAllocationValue, setSuggestedAllocationValue] =
    useState(suggestedAllocation);

  const toggleEdit = (): void => {
    setIsEditing(!isEditing);
  };

  useEffect(() => {
    setSuggestedAllocationValue(suggestedAllocation);
  }, [suggestedAllocation]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px'
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', gap: '15px' }}>
          <Box
            sx={{
              borderRadius: '50%',
              width: '22px',
              height: '22px',
              background: colorCode
            }}
          />
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              fontFamily: 'Be Vietnam Pro',
              color: '#1A1B1F',
              maxWidth: '100px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {project}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: isEditing ? '180px' : '140px',
          justifyContent: 'space-between',
          flexDirection: 'row'
        }}
      >
        <Box
          sx={{
            minWidth: '25px',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'left',
            alignItems: 'left'
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              fontFamily: 'Be Vietnam Pro',
              color: '#1A1B1F'
            }}
          >
            {currentAllocation}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            minWidth: '85px',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {isEditing && (
              <Box
                sx={{
                  maxWidth: '100px',
                  marginRight: '10px'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 400,
                    fontFamily: 'Be Vietnam Pro',
                    color: '#1A1B1F'
                  }}
                >
                  {suggestedAllocation}
                </Typography>
              </Box>
            )}
            {!isEditing && (
              <TextField
                id={id}
                hiddenLabel
                variant="filled"
                value={suggestedAllocationValue}
                sx={{
                  fontSize: '16px',
                  fontWeight: 400,
                  fontFamily: 'Be Vietnam Pro',
                  color: '#1A1B1F',
                  maxWidth: '125px'
                }}
                onChange={(e) => {
                  setSuggestedAllocationValue(e.target.value);
                  setSuggestedAllocation(e.target.value);
                }}
              />
            )}
            {isEditing && (
              <IconButton
                onClick={toggleEdit}
                aria-label="edit"
                disabled={pendingRequests}
              >
                <EditIcon
                  sx={{
                    color: `${pendingRequests === true ? '#848991' : '#2C5DA7'}`
                  }}
                />
              </IconButton>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectMemberAllocationCard;
